<template>
  <div class="jqcalendar input-group">
    <input
      :disabled="disabled"
      v-focus="focus"
      class="datepicker form-control"
      :value="internaldate"
      @keyup.enter="hidepicker"
      @blur="inputchanged"
    />
    <div class="input-group-btn">
      <button :disabled="disabled" class="btn btn-default" @click="clearpicker()" type="button">
        <span class="glyphicon glyphicon glyphicon-remove"></span>
      </button>
      <button :disabled="disabled" tabindex="-1" type="button" @click="picker()" class="btn btn-default">
        <span class="glyphicon glyphicon-calendar"></span>
      </button>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    dateFormat: {
      type: String,
      default: '',
    },
    focus: {
      type: Boolean,
    },
    value: {},
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    internaldate: {
      // getter
      get: function () {
        let datepar
        try {
          // datepar = util.jsDateToStringDate(this.value)
        } catch (e) {
          datepar = this.value
        }

        return datepar
      },
      // setter
      set: function (newValue) {
        // niks doen, doet de datepicker
      },
    },
  },
  mounted: function () {
    $(this.$el)
      .find('.datepicker')
      .datepicker({
        maxDate: '1-1-2200',
        minDate: '1-1-1900',
        showOn: 'button',
        changeMonth: true,
        changeYear: true,
        yearRange: 'c-70:c+20',
        dateFormat: this.dateFormat,
        onSelect: (date) => {
          this.$emit('update-date', date)
        },
      })
  },
  beforeDestroy: function () {
    $(this.$el).find('hide').datepicker('destroy')
  },
  methods: {
    hidepicker: function () {
      this.inputchanged()
      this.$emit('update-enter', '')
    },
    picker: function () {
      $(this.$el).find('.datepicker').datepicker('show')
    },
    clearpicker: function () {
      $(this.$el).find('.datepicker').val('')
      this.$emit('update-date', '')
    },
    inputchanged: function () {
      let val = $(this.$el).find('.datepicker').val()
      if (val === '') {
        this.$emit('update-date', '')
      } else {
        this.internaldate = val
        this.$emit('update-date', val)
      }

      // })
    },
  },
}
</script>
